import React from 'react';
import { FaEdit, FaClock, FaPhoneAlt } from 'react-icons/fa'; // Importing the icons

const HowItWorks = () => {
  return (
    <section className="py-4 bg-white text-blue-800 rounded-lg">
      <div className="max-w-2xl mx-auto text-center p-4">
        {/* <h2 className="text-2xl font-semibold mb-8 animate__animated animate__fadeIn">How It Works</h2> */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {/* Step 1 */}
          <div className="flex p-2 bg-white text-gray-800 rounded-xl shadow-lg hover:scale-105 transition-transform duration-300 ease-in-out">
            <div className="mr-2 text-2xl text-blue-400 mb-2 animate-pulse">
              <FaEdit /> {/* Replace FontAwesome icon with React Icon */}
            </div>
            <a href="#appointment"><h3 className="text-sm font-bold mb-2">#1 Fill Out the Form</h3></a>
          </div>

          {/* Step 2 */}
          <div className="flex p-2 bg-white text-gray-800 rounded-xl shadow-lg hover:scale-105 transition-transform duration-300 ease-in-out">
            <div className="mr-2 text-2xl text-green-400 mb-4 animate-pulse">
              <FaClock /> {/* Replace FontAwesome icon with React Icon */}
            </div>
            <h3 className="text-sm font-bold mb-2">#2 Wait 5 Minutes</h3>
          </div>

          {/* Step 3 */}
          <div className="flex p-2 bg-white text-gray-800 rounded-xl shadow-lg hover:scale-105 transition-transform duration-300 ease-in-out">
            <div className="mr-2 text-2xl text-orange-400 mb-4 animate-pulse">
              <FaPhoneAlt /> {/* Replace FontAwesome icon with React Icon */}
            </div>
            <h3 className="text-sm font-bold mb-2">#3 Get Calls from us</h3>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
